/**
 * Convert values to px
 * @param {number} value
 * @param {boolean} unitless
 * @return {string | number}
 */
export default (value, unitless = false) => {
    const conversion = `${value * window.innerWidth / 100}px`;

    if (unitless) {
        return value * window.innerWidth / 100;
    }

    return conversion;
};
